import React from 'react';
import PropTypes from 'prop-types';
import config from '../config';
import { Badge } from 'react-bootstrap';

const EnvironmentTag = ({ env = config.ENV }) => {

  if (env !== 'prd') {
    return (
      <div id="env-tag">
        <h5><Badge variant="warning">TESTING ENV ({env.toUpperCase()})</Badge></h5>
      </div>
    );
  } else {
    return null;
  }
}

export default EnvironmentTag;

EnvironmentTag.propTypes = {
  env: PropTypes.string
};
